var comingSoonSection = document.querySelector('.coming-soon');

if(comingSoonSection) {
  var comingSoonDataset = comingSoonSection.dataset
  var comingSoonPass = false
  if(comingSoonDataset && comingSoonDataset.pass) {
    comingSoonPass = "comingSoonHide=" + comingSoonDataset.pass
  }
  var decodedCookie = decodeURIComponent(document.cookie);
  var comingSoonCookie = decodedCookie.split(';').find(function(cookie) {
    return cookie.trim() === comingSoonPass.trim()
  })

  if (comingSoonCookie) {
    comingSoonSection.classList.add('hidden');
    document.body.style.overflow = 'auto';
  }
}